import { useEffect, useState } from "react";
import { Badge, Button, Heading, Select, Text, Textarea } from "@/ui";
import { VERIFICATION_TYPES } from "config/constant";
import { NOT_AVAILABLE } from "config/constant";
import styles from "./VerificationPane.module.scss";

const VerificationPane = ({
    inputs,
    inputChange,
    loadingReset,
    statusBerbix,
    selectChange,
    changeBerbixVerificationStatus,
}) => {
    const [status, setStatus] = useState(NOT_AVAILABLE);
    const urlBerbixVerification = `https://mydive.idscan.net/Requests/Details/${inputs?.berbix_id}`;

    useEffect(() => {
        setStatus(
            VERIFICATION_TYPES.find(e => e.value === statusBerbix)?.label ||
                NOT_AVAILABLE,
        );
    }, [statusBerbix]);

    const verificationOptions = VERIFICATION_TYPES.map(option => ({
        value: String(option.value),
        label: option.label,
    }));

    const isAccepted =
        inputs?.berbix_verified === true || inputs?.berbix_verified === "true";
    const isRejected =
        inputs?.berbix_verified === false ||
        inputs?.berbix_verified === "false";
    const berbixVerifiedValue = isAccepted
        ? "true"
        : isRejected
        ? "false"
        : undefined;

    return (
        <div className={`tap__panel_verification ${styles.root}`}>
            <div className={styles.header}>
                <Heading level={5}>User Verifications</Heading>
            </div>
            <div className={styles.layout}>
                <div className={styles.formCol}>
                    <Select
                        fullWidth
                        label="Status"
                        onValueChange={value =>
                            selectChange(
                                { value: value === "true" },
                                "berbix_verified",
                            )
                        }
                        options={verificationOptions}
                        value={berbixVerifiedValue}
                    />
                    <Textarea
                        fullWidth
                        label="Notes"
                        name="note"
                        onChange={inputChange}
                        rows={4}
                        value={inputs?.note || ""}
                    />
                    <div className={styles.actions}>
                        <Button
                            disabled={loadingReset}
                            loading={loadingReset}
                            onClick={changeBerbixVerificationStatus}
                            variant="primary"
                        >
                            Change verification status
                        </Button>
                        <Button
                            onClick={() =>
                                window.open(
                                    urlBerbixVerification,
                                    "_blank",
                                    "noopener,noreferrer",
                                )
                            }
                            type="button"
                            variant="secondary"
                        >
                            Go to Id Scan System
                        </Button>
                        {/* href was: https://dashboard.berbix.com/login */}
                    </div>
                </div>
                <div className={styles.infoCol}>
                    <Text className={styles.infoTitle} variant="label-md">
                        ID Scan
                    </Text>
                    <div className={styles.infoRow}>
                        <Text tone="secondary" variant="body-md">
                            Status
                        </Text>
                        <Badge
                            variant={
                                isAccepted
                                    ? "secondary"
                                    : isRejected
                                    ? "primary"
                                    : "neutral"
                            }
                        >
                            {status}
                        </Badge>
                    </div>
                    <div className={styles.infoRow}>
                        <Text tone="secondary" variant="body-md">
                            Transaction ID
                        </Text>
                        <Badge
                            variant={inputs?.berbix_id ? "primary" : "neutral"}
                        >
                            {inputs?.berbix_id || NOT_AVAILABLE}
                        </Badge>
                    </div>
                    <div className={styles.infoRow}>
                        <Text tone="secondary" variant="body-md">
                            Validation Error
                        </Text>
                        <Badge
                            variant={
                                inputs?.berbix_error ? "primary" : "neutral"
                            }
                        >
                            {inputs?.berbix_error || NOT_AVAILABLE}
                        </Badge>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VerificationPane;
